module.exports = __webpack_public_path__ + "img/booklist.54abeaa.svg";